import { Component, Input, output } from '@angular/core';
import { CallLogQueryKeywords } from '../call-logs-query-editor.component';
import { animate, query, style, transition, trigger } from '@angular/animations';
import { ZiroFormsUpdate } from '../../../forms/ziro-forms-models';

export class CallLogsQueryEditorKeywordConfig {
  keywordValue: { selection: string; value: any };
  choices: { selection: string; value: any }[];
  dataAutomation: string;
  type: string;
  hasError?: boolean;
}

export interface ExpressionEditorKeywordSearchFormData {
  'keyword-search': { label: string; value: string };
}
export interface ExpressionEditorKeywordSearchEntity {
  extensionUsernameOrDeviceName: { selection: string; value: string };
}

@Component({
  selector: 'ziro-call-logs-query-editor-keyword',
  templateUrl: './call-logs-query-editor-keyword.component.html',
  styleUrls: ['./call-logs-query-editor-keyword.component.scss'],
  animations: [
    trigger('custom-ng-select', [
      transition(':enter', [
        query(
          '.ng-dropdown-panel',
          [
            style({ opacity: 0, transform: 'translateY(-100px)' }),
            animate('1s', style({ opacity: 1, transform: 'none' })),
          ],
          { optional: true },
        ),
      ]),
    ]),
  ],
  standalone: false,
})
export class CallLogsQueryEditorKeywordComponent {
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() keyword: CallLogsQueryEditorKeywordConfig;
  readonly keywordWasUpdated = output();
  keywords = CallLogQueryKeywords;
  isCallKeywordQueryDropdownOpen = false;
  hasTheInputChanged = false;

  handleModelChange(): void {
    this.keywordWasUpdated.emit();
  }

  handleInputChange($event: ZiroFormsUpdate<any>): void {
    if (
      $event?.old?.extensionUsernameOrDeviceName?.value !== $event?.new?.extensionUsernameOrDeviceName?.value ||
      $event?.old?.extensionUsernameOrDeviceName?.selection !== $event?.new?.extensionUsernameOrDeviceName?.selection
    ) {
      this.hasTheInputChanged = true;
      this.keyword.keywordValue = $event.new.extensionUsernameOrDeviceName;
    }
  }

  handlePopoverClose(): void {
    if (this.hasTheInputChanged) {
      this.keywordWasUpdated.emit();
      this.hasTheInputChanged = false;
    }
  }

  handleSelectionChange(): void {
    (this.keyword as CallLogsQueryEditorKeywordConfig).keywordValue.value = '';
  }

  get inputTemplatePlaceholder(): string {
    const { selection: dropdownValue, value: inputValue } = (this.keyword as CallLogsQueryEditorKeywordConfig)
      .keywordValue;
    if (dropdownValue) {
      return inputValue ? `${dropdownValue} ${inputValue}` : dropdownValue;
    }

    return this.keyword.type;
  }
}
